import React, { useState, useEffect } from 'react';

import { useContext as useUsersContext } from 'components/Users/Context';
import ListView from './Views/List/Index';
import SuccessInvitedView from './Views/SuccessInvited/Index';

export default function Main() {
  const [view, setView] = useState('list');

  const { dispatch: dispatchUsers, actions: actionsUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  return (
    <>
      {view === 'list' && <ListView setView={setView} />}
      {view === 'invited' && <SuccessInvitedView />}
    </>
  );
}
